module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-padding page-content-bg-a",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    attrs: {
      "id": "accountselect"
    }
  }, [_c('h1', [_vm._v("Choose your Apollo Account. Sign up is free!")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "accountselectrow"
    }
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "account-type"
  }, [_c('h1', [_vm._v("Buy Apollo Products")]), _vm._v(" "), _c('p', [_vm._v("For people who want to buy apollo lighting fixtures")]), _vm._v(" "), _c('router-link', {
    staticClass: "button-type-g",
    attrs: {
      "to": "/registration/buyer"
    }
  }, [_vm._v("Get Started")]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Buy all kinds of lighting fixtures from Apollo")]), _vm._v(" "), _c('li', [_vm._v("Other information that can be used to promote this feature")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "account-type"
  }, [_c('h1', [_vm._v("Be a supplier of Apollo")]), _vm._v(" "), _c('p', [_vm._v("For people who want be a supplier of Apollo")]), _vm._v(" "), _c('button', {
    staticClass: "button-type-g button-type-g-disabled",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("Coming Soon")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Buy all kinds of lighting fixtures from Apollo")]), _vm._v(" "), _c('li', [_vm._v("Other information that can be used to promote this feature")]), _vm._v(" "), _c('li', [_vm._v("Propose products to Apollo")]), _vm._v(" "), _c('li', [_vm._v("Get paid by Apollo to be something information to be part here")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f34bd962"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountSelection.vue
// module id = 166
// module chunks = 0